import { composeIO } from 'react-compose-io'
import { adicionarNovoParametroIO } from './AdicionarNovoParametro.IO'
import AdicionarNovoParametroView from './AdicionarNovoParametro.View'

export const AdicionarNovoParametro = composeIO(AdicionarNovoParametroView, adicionarNovoParametroIO)
